import React from "react";
import { HomeIcon, ChevronLeftIcon, BellIcon } from "lucide-react";
import { AGENT, BRAND } from "../lib/data";
import { Logo } from "./Logo";
type TopBarProps = {
  onHome?: () => void;
  onBack?: () => void;
  backLabel?: string;
  title?: string;
  showAgent?: boolean;
};
export function TopBar({
  onHome,
  onBack,
  backLabel,
  title,
  showAgent = true
}: TopBarProps) {
  return <header className="sticky top-0 z-30 w-full border-b border-neutral-200 bg-white/80 backdrop-blur-md" data-id="element-861" data-mp="2qs80bac8kzaw">
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-5 sm:px-8" data-id="element-862" data-mp="2lsv4w17aujwp">
        <div className="flex items-center gap-3" data-id="element-863" data-mp="2h24xkifbc6zd">
          <button onClick={onHome} className="flex items-center rounded-lg px-1 py-1 transition hover:opacity-80" aria-label="Go to home" data-id="element-864" data-mp="2h0ty2uswhle2">
            <Logo className="h-6 w-auto sm:h-7" data-id="element-865" data-mp="39kk0bqff3ohv" />
          </button>
          {onBack && <>
              <span className="mx-1 hidden h-5 w-px bg-neutral-200 sm:block" data-id="element-866" data-mp="34qy04xqfxd2y" />
              <button onClick={onBack} className="flex items-center gap-1 rounded-lg px-2.5 py-1.5 text-sm font-medium text-neutral-600 transition hover:bg-neutral-100 hover:text-neutral-900" data-id="element-867" data-mp="26iv7us53v28">
                <ChevronLeftIcon className="h-4 w-4" data-id="element-868" data-mp="3oizkrarp7n5k" />
                {backLabel || "Back"}
              </button>
            </>}
          {title && <span className="hidden text-sm font-medium text-neutral-500 md:block" data-id="element-869" data-mp="3el32lz0cfrxy">{title}</span>}
        </div>

        <div className="flex items-center gap-3" data-id="element-870" data-mp="3jjmqi4yhzdsy">
          {onHome && <button onClick={onHome} className="hidden items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium text-neutral-600 transition hover:bg-neutral-100 hover:text-neutral-900 sm:flex" data-id="element-871" data-mp="35niy8h76pfj4">
              <HomeIcon className="h-4 w-4" data-id="element-872" data-mp="18to4zqamc0yr" />
              Home
            </button>}
          {showAgent && <>
              <button className="relative rounded-full p-2 text-neutral-500 transition hover:bg-neutral-100 hover:text-neutral-900" data-id="element-873" data-mp="16g2mvkl9qzj1">
                <BellIcon className="h-5 w-5" data-id="element-874" data-mp="12fin099b9ht7" />
                <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full ring-2 ring-white" style={{
              backgroundColor: BRAND.accent
            }} data-id="element-875" data-mp="xdjj8y9nsivq" />
              </button>
              <div className="flex items-center gap-2.5" data-id="element-876" data-mp="1q1p4dm4mk9w3">
                <img src={AGENT.avatar} alt={AGENT.fullName} className="h-9 w-9 rounded-full object-cover ring-1 ring-neutral-200" data-id="element-877" data-mp="1l45qinbu9z4o" />
                <div className="hidden leading-tight sm:block" data-id="element-878" data-mp="1bedrngwpijue">
                  <div className="text-sm font-semibold text-neutral-900" data-id="element-879" data-mp="1bc00vk927tsn">{AGENT.fullName}</div>
                  <div className="text-xs text-neutral-500" data-id="element-880" data-mp="28ut3vo4ixgym">Agent</div>
                </div>
              </div>
            </>}
        </div>
      </div>
    </header>;
}